import React, { useContext, useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import PsContext from "../../context";
import { _MY_ELECTIVE_SELECTION_LIST } from "../../models/studentModel";
import { Divider, List, ListItem, ListItemText } from "@mui/material";

const ElectiveSelectedList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    _MY_ELECTIVE_SELECTION_LIST().then((res) => {
      if (res.status == "1") {
        setDataList(res.data);
      } else {
        setDataList([]);
      }

      setLoader(false);
    });
  };

  return (
    <>
      <Card>
        <Card.Header className="card-header-bg fw-bold text-uppercase">
          My Elective List
        </Card.Header>
        <Card.Body className="p-0">
          <List>
            {dataList.map((item, i) => {
              return (
                <>
                  <ListItem>
                    <ListItemText
                      secondary={item.elective_title}
                      primary={
                        <>
                          {item.subject_code}-{item.subject_name}
                        </>
                      }
                    ></ListItemText>
                  </ListItem>
                  <Divider />
                </>
              );
            })}
          </List>
        </Card.Body>
      </Card>
    </>
  );
};
export default ElectiveSelectedList;
